import { useUnit } from 'effector-react';
import {
  $usersList,
  $usersListTableProps,
  changeUsersListTableEv,
  getUsersListFx,
  setAdminBlockUserModalEv,
  setAdminChangePassModalEv,
  setAdminCreateUserModalEv,
  unblockUserEv,
  unblockUserFx,
  UsersListGate,
} from '../../models/adminSecurityModel/index.js';
import {
  CheckCircleOutlined,
  CheckOutlined,
  CloseOutlined,
  PlusOutlined,
  StopOutlined,
  UnlockOutlined,
} from '@ant-design/icons';
import Card from 'antd/es/card';
import Form from 'antd/es/form';
import Input from 'antd/es/input';
import Popconfirm from 'antd/es/popconfirm';
import Table from 'antd/es/table';
import Tooltip from 'antd/es/tooltip';
import ButtonGroup from 'antd/es/button/button-group';
import Button from 'antd/es/button';
import Space from 'antd/es/space';
import { $userInfo } from '../../models/authModel/index.js';
import { useMemo } from 'react';
import AdminPassChangeModal from '../../pages/Profile/components/AdminPassChangeModal.jsx';
import AdminCreateUserModal from '../../pages/Profile/components/AdminCreateUserModal.jsx';
import AdminBlockUserModal from '../../pages/Profile/components/AdminBlockUserModal.jsx';
import dayjs from 'dayjs';

export default function UsersList() {
  const curUsr = useUnit($userInfo);
  const isAdmin = useMemo(() => {
    return curUsr.role === 'admin';
  }, [curUsr]);
  const isSuperAdmin = useMemo(() => {
    return curUsr.role === 'superadmin';
  }, [curUsr]);

  const { data, count } = useUnit($usersList);

  const setCreateUserModal = useUnit(setAdminCreateUserModalEv);
  const setBlockUserModal = useUnit(setAdminBlockUserModalEv);

  const [searchForm] = Form.useForm();

  const listLoading = useUnit(getUsersListFx.pending);
  const unblockLoading = useUnit(unblockUserFx.pending);
  const loading = listLoading || unblockLoading;

  const table = useUnit($usersListTableProps);
  const changeTable = useUnit(changeUsersListTableEv);

  const unblock = useUnit(unblockUserEv);
  const setPassModal = useUnit(setAdminChangePassModalEv);

  const columns = [
    { dataIndex: 'id', title: 'ID' },
    { dataIndex: 'username', title: 'Имя пользователя' },
    { dataIndex: 'gov_id', title: 'БИН/ИИН' },
    {
      dataIndex: 'confirmed',
      title: 'Подтвержден',
      align: 'center',
      render: (c) => (c ? <CheckOutlined /> : <CloseOutlined />),
    },
    { dataIndex: 'email', title: 'E-mail' },
    { dataIndex: 'work_phone', title: 'Раб. Тел.' },
    {
      dataIndex: 'is_blocked',
      title: 'Заблокирован',
      align: 'center',
      render: (b) => (b ? <CheckOutlined /> : <CloseOutlined />),
    },
    {
      dataIndex: 'block_date',
      title: 'Дата блок-ки',
      render: (date) => (date ? dayjs(date).format('DD.MM.YYYY HH:mm') : null),
    },
    {
      dataIndex: 'block_reason',
      title: 'Причина блок-ки',
    },
    {
      key: 'actions',
      title:
        isAdmin || isSuperAdmin ? (
          <Button
            type={'primary'}
            icon={<PlusOutlined />}
            onClick={() => setCreateUserModal(true)}
          />
        ) : (
          'Действия'
        ),
      align: 'center',
      render: (u) =>
        !(isAdmin || isSuperAdmin) ||
        (isAdmin && u.role === 'superadmin') ? null : (
          <ButtonGroup>
            {!u.is_blocked ? (
              <Tooltip title={'Заблокировать'}>
                <Button
                  icon={<StopOutlined />}
                  onClick={() => setBlockUserModal({ open: true, uId: u.id })}
                />
              </Tooltip>
            ) : (
              <Tooltip title={'Разблокировать'}>
                <Popconfirm
                  title={
                    'Вы уверены, что хотите разблокировать данного пользователя?'
                  }
                  okText={'Да'}
                  onConfirm={() => unblock(u.id)}
                >
                  <Button icon={<CheckCircleOutlined />} />
                </Popconfirm>
              </Tooltip>
            )}
            <Tooltip title={'Сменить пароль'}>
              <Button
                icon={<UnlockOutlined />}
                onClick={() => setPassModal({ uId: u.id, open: true })}
              />
            </Tooltip>
          </ButtonGroup>
        ),
    },
  ];

  return (
    <>
      <AdminPassChangeModal setModal={setPassModal} />
      <AdminCreateUserModal isAdmin={isAdmin} isSuperAdmin={isSuperAdmin} />
      <AdminBlockUserModal />
      <UsersListGate />
      <Card style={{ marginBottom: 24 }}>
        <Form
          layout={'vertical'}
          form={searchForm}
          onFinish={(values) => changeTable(values)}
        >
          <Space direction={'horizontal'} size={'middle'}>
            <Form.Item name={'username'} label={'Логин'}>
              <Input />
            </Form.Item>
            <Form.Item name={'gov_id'} label={'БИН/ИИН'}>
              <Input />
            </Form.Item>
            <Form.Item name={'email'} label={'Email'}>
              <Input />
            </Form.Item>
            <ButtonGroup style={{ marginTop: 6 }}>
              <Button type={'primary'} onClick={() => searchForm.submit()}>
                Поиск
              </Button>
              <Button
                danger
                onClick={() => {
                  searchForm.resetFields();
                  changeTable({ gov_id: null, email: null, username: null });
                }}
              >
                Сбросить
              </Button>
            </ButtonGroup>
          </Space>
        </Form>
      </Card>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          onChange: (curPage, pageSize) => {
            changeTable({
              page: curPage,
              limit: pageSize,
            });
          },
          total: count,
          current: table.page,
          pageSize: table.limit,
        }}
      />
    </>
  );
}
